export const handleChangeDataPageBlog = (name, value) => ({
    type: 'CHANGE_DATA_PAGE_BLOG', name, value
});